import { render, staticRenderFns } from "./submissions.datagrid.vue?vue&type=template&id=e4ded29c&scoped=true&"
import script from "./submissions.datagrid.vue?vue&type=script&lang=js&"
export * from "./submissions.datagrid.vue?vue&type=script&lang=js&"
import style0 from "./submissions.datagrid.vue?vue&type=style&index=0&id=e4ded29c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ded29c",
  null
  
)

export default component.exports